import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import TranslationContext, {TranslationUtils} from 'contexts/TranslationContext';

export type WithTranslationProps = Required<TranslationUtils>;

export default function withTranslation(keyset = 'common') {
    return function <T extends WithTranslationProps>(WrappedComponent: React.ComponentType<T>) {
        class WithTranslation extends React.Component<Omit<T, keyof WithTranslationProps>> {
            static displayName = `withTranslation(${
                WrappedComponent.displayName || WrappedComponent.name || 'Component'
            })`;
            static contextType = TranslationContext;

            render() {
                const {i18n} = this.context;
                return (
                    <WrappedComponent
                        {...(this.props as T)}
                        i18n={i18n}
                        i18nK={i18n.bind(null, keyset)}
                    />
                );
            }
        }

        // Copies non-react specific statics from a child component to a parent component
        hoistNonReactStatics(WithTranslation, WrappedComponent);
        return WithTranslation;
    };
}
